/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandCss3 = createReactComponent("brand-css3", "IconBrandCss3", [
  ["path", { d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z", key: "svg-0" }],
  [
    "path",
    { d: "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5", key: "svg-1" }
  ]
]);

export { IconBrandCss3 as default };
//# sourceMappingURL=IconBrandCss3.js.map
